export default __webpack_public_path__ + "static/media/app-register.8233bbe7.png";